/**
 * dateUtils.ts
 *
 * Shared date helpers. The one rule that matters here: never use
 * `new Date().toISOString().split('T')[0]` to get "today's date" —
 * toISOString() is always UTC, and Eastern is 4-5 hours behind it.
 * Between ~8pm and midnight local time, that pattern silently returns
 * TOMORROW's date, which caused getUpcomingEvents()/getVenueEvents()
 * to drop today's events during peak evening usage.
 *
 * Use todayLocalDateString() (or todayLocalDateString(date) for a
 * specific instant) everywhere "today" needs to become a YYYY-MM-DD
 * string for a Supabase date-column comparison.
 */

/** Local calendar date as YYYY-MM-DD, using the device's own timezone. */
export function localDateString(d: Date = new Date()): string {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

/** Today's local calendar date as YYYY-MM-DD. */
export function todayLocalDateString(): string {
  return localDateString(new Date())
}

/** Local calendar date N days from now (negative = past) as YYYY-MM-DD. */
export function localDateStringOffset(days: number): string {
  const d = new Date()
  d.setDate(d.getDate() + days)
  return localDateString(d)
}
